import { useEffect, useState } from 'react'

import { Segment, Input,Icon, Grid, Loader,Button } from 'semantic-ui-react'
import {  getAseguradoras,deleteAseguradora } from '../../../../api/Orion/aseguradora';
import { ModalBasic,PaginationTable } from '../../../../components/Common';
import { useHistory } from "react-router-dom";
import { ListadoAseguradoras } from '../../../../components/Admin/Orion';
import { HeaderPage } from '../../../../components/Admin';
import { toast } from 'react-toastify'
import "./AbmAdmin.scss"
import { getPermissions } from '../../../../components/Common';
import { useAuth } from '../../../../hooks';
import { animateScroll as scroll } from 'react-scroll'

export  function AseguradoraOrionList() {
	const {auth} = useAuth()
    const [aseguradoras,setAseguradoras] = useState([])
    const [loading,setLoading] = useState(true)
    const [showModal,setShowModal] = useState(false)
    const [titleModal,setTitleModal] = useState(null)
    const [dataModal,setDataModal] = useState(null)
    const [contentModal,setContentModal] = useState(null)
    const [refetch, setRefetch] = useState(false)
	const [activePage, setActivePage] = useState(1);
	const [countPage, setCountPage] = useState(1);
	const [searchActive, setSearchActive] = useState("");
	
	const limitPagination = 10
    const history = useHistory()
	const fetchAseguradoras = async (request = null) =>{
		
		const aseguradoras = await getAseguradoras(request)

		setAseguradoras(aseguradoras.results)
		setCountPage(aseguradoras.count)
		setLoading(false)
		
	} 
    useEffect(()=>{
		scroll.scrollToTop();
		let searchExistentes = sessionStorage.getItem('orion_aseguradoras_search');
		if(searchExistentes){
			setSearchActive(searchExistentes);
			fetchAseguradoras(`page=1&search=${searchExistentes}`);
		} else {
			fetchAseguradoras(`page=1`); 
		}
    },[refetch])
	
    const onRefetch = () => setRefetch((prev) => !prev);
	const openCloseModal = ()=>{
		
		setShowModal((prev)=>!prev)
	}
   	const onDeleteAseguradora =  async(aseguradora)=>{
		setContentModal(<p>Desea eliminar aseguradora {aseguradora.long_name} ?</p>)
		setTitleModal("Eliminar aseguradora")
		setShowModal(true)
		setDataModal(aseguradora.id)
    

  	}
  	const openConfirmModal = async(id)=>{
		try {
			let response = await deleteAseguradora(id)
		
			toast.success(response.data)
			setShowModal(false)
			onRefetch()
		} catch (error) {
			console.error("Error en AseguradoraOrionList:", error)
		} 
  	}
  	const crearAseguradora = (id) => {
    	history.push(`/admin/aseguradora_orion/crear`);
  	}

  	const onEditAseguradora = (aseguradora) => {
		history.push(`/admin/aseguradora_orion/edit/id/${aseguradora.id}`);
  	}
	const onShowAseguradora = (aseguradora) => {
		history.push(`/admin/aseguradora_orion/show/id/${aseguradora.id}`);
  	}
	


  	const onSearch =  (e) => {
		const value = e.target.value;
		setSearchActive(value);
		sessionStorage.setItem('orion_aseguradoras_search', value);
		fetchAseguradoras(`page=1&search=${value}`);
		setActivePage(1);
  	}
  	const onChange = (e, pageInfo) => {
		let request = `page=${pageInfo.activePage.toString()}`;
		if(searchActive !== "") request += `&search=${searchActive}`;
    	fetchAseguradoras(request);

		setActivePage(pageInfo.activePage);
		
	};
  return (
    <div>
		
		<HeaderPage title="Aseguradoras" btnTitle="Agregar aseguradora" btnClick={crearAseguradora} permitionName="add_aseguradora"/>
		
		
		   <Grid as={Segment} className='segment_search'>
				<Grid.Row >
					<Grid.Column computer={3} mobile={16} tablet={16}>  
						<Input 
							fluid
							
						icon={<Icon name='search' className='color_search' inverted circular />} 
						className="input_search"  
						inverted 
						placeholder='Buscar...' 
						value={searchActive}
						onChange={onSearch}
					/>
					</Grid.Column>
					<Grid.Column computer={11} mobile={16} tablet={16}>


					</Grid.Column>
					<br></br>
					<Grid.Column computer={2} mobile={16} tablet={16}>
					{getPermissions("add_aseguradora",auth) && (
						<Button circular basic positive onClick={crearAseguradora}>
							Agregar aseguradora
						</Button>
            )}
					</Grid.Column>

			
			
			</Grid.Row>
			</Grid>
		   
      <Grid>
        <Grid.Row>
          <Grid.Column computer={16}>
        
          </Grid.Column>
        </Grid.Row>
      </Grid>

	  {loading ? (
		<Loader active inline="centered">
			Cargando...
		</Loader>
	  ):(
		<ListadoAseguradoras 
      aseguradoras={aseguradoras} 
      onDeleteAseguradora={onDeleteAseguradora}
      onEditAseguradora={onEditAseguradora}
      onShowAseguradora={onShowAseguradora}
	  countPage={countPage}
	  pagination={<PaginationTable 
		aseguradoras={aseguradoras} 
		onChange={onChange}
		activePage={activePage}
		countPage={countPage}
		
		limitPagination={limitPagination}
		/>}
    />
  		)}

      <ModalBasic 
      show={showModal} 
      size="small" 
      title={titleModal} 
      children={contentModal}
      onClose={openCloseModal}
      onConfirm={openConfirmModal}
	  dataModal={dataModal}
      />
    </div>
  )
}
